<div class="width-84 ml-5 print-all-content" [ngClass]="IsGlossary?'mt-2':'mt-104px'" tabindex="0">
  <div class="print-content-hide">
    <h1 id="pageHeading" role="main" class="version-general-header mtb-0-2" [innerHTML]="title">
    </h1>
  </div>
  <div class="otherSource sub-content-description" tabindex="0" [innerHTML]="content" (click)="openLinkById($event)" (contextmenu)="onRightClick($event)" >
  </div>

</div>
